import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PlayerProfilesStats from './js/player-profiles-stats.component';

ComponentsFactory.getInstance().define('player-profiles-stats', PlayerProfilesStats);
